/**
 * Attach custom logo files to Quote Cart items and quote notes.
 * Quottee's draft-order API only accepts variant IDs, so artwork URLs
 * are stored on the quote item and appended to delivery notes.
 */
(function (window, document) {
  'use strict';

  var pendingByVariant = {};
  var wrapped = false;
  var fetchHooked = false;

  function waitForQuottee(done) {
    if (window.Quottee && typeof window.Quottee.addProductToQuote === 'function') {
      done(window.Quottee);
      return;
    }
    window.setTimeout(function () { waitForQuottee(done); }, 60);
  }

  function findUpload(sourceEl) {
    if (!sourceEl || !sourceEl.closest) return null;
    var form = sourceEl.closest('form') || sourceEl.closest('.productView') || sourceEl.closest('.product-item');
    if (!form) return null;
    return form.querySelector('custom-file-upload');
  }

  function selectedVariantId(sourceEl, product) {
    var form = sourceEl && sourceEl.closest ? sourceEl.closest('form') : null;
    var input = form && form.querySelector('[name="id"]');
    if (input && input.value) return String(input.value);
    if (product && product.selectedVariantId) return String(product.selectedVariantId);
    if (product && product.variants && product.variants[0]) return String(product.variants[0].id);
    return '';
  }

  function logoFromProperties(properties) {
    if (!properties) return null;
    var name = properties.Logo || properties.logo || properties['Logo file'] || '';
    if (!name) {
      Object.keys(properties).forEach(function (key) {
        if (name) return;
        if (/logo|artwork|upload/i.test(key) && String(key).charAt(0) !== '_') {
          name = properties[key];
        }
      });
    }
    if (!name) return null;
    var value = String(name);
    var isUrl = /^https?:\/\//i.test(value) || value.indexOf('//cdn.shopify') === 0;
    return {
      name: isUrl ? decodeURIComponent(value.split('/').pop().split('?')[0] || 'logo') : value,
      url: isUrl ? value : ''
    };
  }

  function uploadLogo(variantId, file, propertyName) {
    var fd = new FormData();
    fd.append('id', variantId);
    fd.append('quantity', 1);
    fd.append('properties[' + (propertyName || 'Logo') + ']', file);
    fd.append('properties[Artwork required]', 'Yes');
    return fetch('/cart/add.js', { method: 'POST', body: fd, credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('cart add ' + response.status);
        return response.json();
      })
      .then(function (line) {
        var props = line.properties || {};
        var url = props[propertyName] || props.Logo || '';
        var key = line.key;
        if (!key) return { name: file.name, url: url };
        return fetch('/cart/change.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: key, quantity: 0 })
        }).then(function () {
          return { name: file.name, url: url };
        }).catch(function () {
          return { name: file.name, url: url };
        });
      });
  }

  function attachLogoToState(Q, variantId, logo) {
    if (!logo) return;
    var state = Q.getQuoteState();
    var key = Q.variantKey(variantId);
    var changed = false;
    (state.furniture || []).forEach(function (item) {
      if (Q.variantKey(item.variantId) === key) {
        item.logoName = logo.name || '';
        item.logoUrl = logo.url || '';
        item.needsArtwork = true;
        changed = true;
      }
    });
    if (changed) Q.saveQuoteState(state);
  }

  function noticeHtml(text) {
    return '<p class="quottee-artwork-notice">Artwork attached: ' + text + '</p>';
  }

  function isZeroMoney(text) {
    var trimmed = String(text || '').replace(/\s+/g, ' ').trim();
    if (!trimmed || trimmed.length > 24 || !/\d/.test(trimmed)) return false;
    return /^0+$/.test(trimmed.replace(/[^0-9]/g, ''));
  }

  function replaceZeroQuotePrices() {
    var label = window.priceToBeQuoted || 'Price to be Quoted';
    var nodes = document.querySelectorAll('.quottee-root [class*="__price"]');
    Array.prototype.forEach.call(nodes, function (node) {
      if (!isZeroMoney(node.textContent)) return;
      if (node.textContent.trim() === label) return;
      node.textContent = label;
    });
  }

  function injectNotices(Q) {
    replaceZeroQuotePrices();
    var state = Q.getQuoteState();
    (state.furniture || []).forEach(function (item) {
      if (!item.logoName && !item.logoUrl) return;
      var article = document.querySelector('[data-quottee-furniture-line="' + item.variantId + '"]');
      if (!article || article.querySelector('.quottee-artwork-notice')) return;
      var host = article.querySelector('.quottee-drawer__details') || article;
      host.insertAdjacentHTML('beforeend', noticeHtml(Q.escapeHtml(item.logoName || 'logo file')));
    });

    var cart = Q.runtime && Q.runtime.lastCart;
    if (!cart || !cart.items) return;
    cart.items.forEach(function (item) {
      var logo = logoFromProperties(item.properties);
      if (!logo) return;
      var title = item.product_title || item.title || '';
      var labels = document.querySelectorAll('.quottee-cart-option');
      Array.prototype.forEach.call(labels, function (label) {
        var copy = label.querySelector('.quottee-cart-option__title');
        if (!copy || copy.textContent.trim() !== title) return;
        if (label.querySelector('.quottee-artwork-notice')) return;
        var metaHost = label.querySelector('.quottee-cart-option__copy') || label;
        metaHost.insertAdjacentHTML('beforeend', noticeHtml(Q.escapeHtml(logo.name)));
      });
    });
  }

  function artworkNoteLines(Q) {
    var lines = [];
    var state = Q.getQuoteState();
    (state.furniture || []).forEach(function (item) {
      if (!item.logoName && !item.logoUrl) return;
      lines.push(
        (item.title || 'Item') + ': ' + (item.logoName || 'logo attached') +
        (item.logoUrl ? ' — ' + item.logoUrl : '')
      );
    });
    var cart = Q.runtime && Q.runtime.lastCart;
    if (cart && cart.items) {
      cart.items.forEach(function (item) {
        if (!Q.isIncluded(state, Q.cartLineId(item))) return;
        var logo = logoFromProperties(item.properties);
        if (!logo) return;
        var title = item.product_title || item.title || 'Cart item';
        lines.push(title + ': ' + logo.name + (logo.url ? ' — ' + logo.url : ''));
      });
    }
    if (!lines.length) return '';
    return 'Artwork required:\n' + lines.join('\n');
  }

  function hookFetch(Q) {
    if (fetchHooked || typeof window.fetch !== 'function') return;
    fetchHooked = true;
    var originalFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      if (url.indexOf('/apps/quottee/quote') !== -1 && init && init.body) {
        try {
          var payload = JSON.parse(init.body);
          var extra = artworkNoteLines(Q);
          if (extra) {
            payload.delivery = payload.delivery || {};
            var existing = String(payload.delivery.notes || '').trim();
            var next = existing ? extra + '\n\n' + existing : extra;
            if (next.length > 2000) next = next.slice(0, 1997) + '...';
            payload.delivery.notes = next;
            init = Object.assign({}, init, { body: JSON.stringify(payload) });
          }
        } catch (err) {}
      }
      return originalFetch.call(this, input, init);
    };
  }

  function wrapQuottee(Q) {
    if (wrapped) return;
    wrapped = true;

    var originalAddProduct = Q.addProductToQuote;
    Q.addProductToQuote = function (product, sourceEl) {
      var upload = findUpload(sourceEl);
      if (upload && typeof upload.validate === 'function' && !upload.validate()) {
        return false;
      }
      var file = upload && typeof upload.getFile === 'function' ? upload.getFile() : null;
      if (!file) return originalAddProduct.call(Q, product, sourceEl);

      var variantId = selectedVariantId(sourceEl, product);
      var propertyName = typeof upload.getPropertyName === 'function' ? upload.getPropertyName() : 'Logo';
      Q.runtime.addInFlight = true;
      if (sourceEl) sourceEl.disabled = true;
      uploadLogo(variantId, file, propertyName)
        .then(function (logo) {
          pendingByVariant[Q.variantKey(variantId)] = logo;
          Q.runtime.addInFlight = false;
          originalAddProduct.call(Q, product, sourceEl);
          attachLogoToState(Q, variantId, logo);
          window.setTimeout(function () { injectNotices(Q); }, 50);
        })
        .catch(function () {
          pendingByVariant[Q.variantKey(variantId)] = { name: file.name, url: '' };
          Q.runtime.addInFlight = false;
          originalAddProduct.call(Q, product, sourceEl);
          attachLogoToState(Q, variantId, pendingByVariant[Q.variantKey(variantId)]);
        })
        .then(function () {
          Q.runtime.addInFlight = false;
          if (sourceEl) sourceEl.disabled = false;
        });
      return true;
    };

    var originalAddItem = Q.addFurnitureItem;
    Q.addFurnitureItem = function (item, quantity) {
      var logo = pendingByVariant[Q.variantKey(item.variantId)];
      if (logo) {
        item.logoName = logo.name;
        item.logoUrl = logo.url;
        item.needsArtwork = true;
      }
      var state = originalAddItem.call(Q, item, quantity);
      if (logo) attachLogoToState(Q, item.variantId, logo);
      return state;
    };

    function wrapRender(name) {
      if (typeof Q[name] !== 'function') return;
      var original = Q[name];
      Q[name] = function () {
        var result = original.apply(Q, arguments);
        window.setTimeout(function () { injectNotices(Q); }, 0);
        return result;
      };
    }

    wrapRender('renderQuoteDrawer');
    wrapRender('refreshDrawer');
    hookFetch(Q);

    if (typeof Q.showAddedPopup === 'function' && !Q.showAddedPopup.__artworkPopup) {
      var originalShowAdded = Q.showAddedPopup;
      Q.showAddedPopup = function (product, variant) {
        var result = originalShowAdded.apply(Q, arguments);
        enhanceAddedDialog(product, variant);
        refreshCartBubbles();
        return result;
      };
      Q.showAddedPopup.__artworkPopup = true;
    }

    if (typeof Q.saveQuoteState === 'function' && !Q.saveQuoteState.__artworkBubble) {
      var originalSave = Q.saveQuoteState;
      Q.saveQuoteState = function () {
        var result = originalSave.apply(Q, arguments);
        refreshCartBubbles();
        return result;
      };
      Q.saveQuoteState.__artworkBubble = true;
    }
  }

  function mediaUrl(value) {
    if (!value) return '';
    if (typeof value === 'string') return value;
    return value.src || value.url || '';
  }

  function productHref(product) {
    if (!product) return '';
    if (product.url) return product.url;
    if (product.handle) return '/products/' + product.handle;
    return '';
  }

  function productImage(product, variant) {
    var url = mediaUrl(variant && variant.featured_image)
      || mediaUrl(variant && variant.image)
      || mediaUrl(product && product.featured_image)
      || mediaUrl(product && product.image)
      || mediaUrl(product && product.featured_media && product.featured_media.preview_image)
      || mediaUrl(product && product.images && product.images[0]);
    if (url) return url;
    try {
      var state = window.Quottee.getQuoteState();
      var id = variant && (variant.id || variant.variantId);
      var items = (state.furniture || []).slice().reverse();
      var match = items.find(function (item) {
        return !id || String(item.variantId) === String(id);
      });
      return (match && match.image) || '';
    } catch (err) {
      return '';
    }
  }

  function enhanceAddedDialog(product, variant) {
    var dialog = document.querySelector('[data-quottee-added-dialog]');
    if (!dialog) return;
    var message = dialog.querySelector('[data-quottee-added-message]');
    var actions = dialog.querySelector('.quottee-added__actions');
    if (!message || !actions) return;

    var name = (product && product.title) || '';
    var variantTitle = (variant && variant.title) || '';
    if (variantTitle && variantTitle !== 'Default Title') {
      name = name ? name + ' - ' + variantTitle : variantTitle;
    }
    if (!name) {
      name = (message.textContent || '').replace(/\s*is added to your Quote Cart\.?\s*$/i, '');
    }

    var added = dialog.querySelector('.product-added');
    if (!added) {
      added = document.createElement('div');
      added.className = 'product-added clearfix';
      dialog.appendChild(added);
    }

    var href = productHref(product);
    var image = productImage(product, variant);
    var imageLink = added.querySelector('.product-image');
    if (!imageLink) {
      imageLink = document.createElement('a');
      imageLink.className = 'product-image';
      added.appendChild(imageLink);
    }
    if (href) imageLink.href = href;
    var img = imageLink.querySelector('img');
    if (image) {
      if (!img) {
        img = document.createElement('img');
        img.alt = '';
        imageLink.appendChild(img);
      }
      img.src = image;
      img.alt = name;
      imageLink.hidden = false;
    } else {
      imageLink.hidden = true;
    }

    var info = added.querySelector('.product-info');
    if (!info) {
      info = document.createElement('div');
      info.className = 'product-info';
      added.appendChild(info);
    }
    var titleWrap = info.querySelector('.product-title');
    if (!titleWrap) {
      titleWrap = document.createElement('div');
      titleWrap.className = 'product-title';
      info.appendChild(titleWrap);
    }
    var titleLink = titleWrap.querySelector('.title');
    if (!titleLink) {
      titleLink = document.createElement('a');
      titleLink.className = 'title';
      titleWrap.appendChild(titleLink);
    }
    if (href) titleLink.href = href;
    titleLink.textContent = name;
    var text = titleWrap.querySelector('.text');
    if (!text) {
      text = document.createElement('span');
      text.className = 'text';
      titleWrap.appendChild(text);
    }
    text.textContent = 'is added to your Quote Cart.';

    actions.classList.add('product-action', 'clearfix');
    Array.prototype.forEach.call(actions.querySelectorAll('.quottee-added__action'), function (button) {
      button.classList.add('button', 'button--secondary');
    });
    if (actions.parentElement !== info) info.appendChild(actions);
    message.hidden = true;
  }

  var bubbleLastWritten = new WeakMap();
  var bubbleWriting = false;
  var knownShopifyCount = null;

  function quoteQty() {
    try {
      if (window.Quottee && typeof window.Quottee.furnitureCountFromStorage === 'function') {
        return Number(window.Quottee.furnitureCountFromStorage()) || 0;
      }
    } catch (err) {}
    try {
      var raw = window.localStorage.getItem('quottee:v1:quote') || window.localStorage.getItem('quottee:v0.1:quote');
      if (!raw) return 0;
      var state = JSON.parse(raw);
      return (state.furniture || []).reduce(function (sum, item) {
        return sum + Number(item.quantity || 0);
      }, 0);
    } catch (err) {
      return 0;
    }
  }

  function parseShopifyText(text) {
    var current = String(text || '').trim();
    if (!current || current.indexOf('+') !== -1) return null;
    if (current === '99+') return 99;
    var numeric = parseInt(current, 10);
    if (isNaN(numeric) || String(numeric) !== current) return null;
    return numeric;
  }

  function bubbleLabel(shopifyCount, quoteCount) {
    if (quoteCount > 0) return String(quoteCount) + '+' + String(shopifyCount);
    return shopifyCount >= 100 ? '99+' : String(shopifyCount);
  }

  function renderBubble(node, shopifyCount) {
    var quoteCount = quoteQty();
    var label = bubbleLabel(shopifyCount, quoteCount);
    node.setAttribute('data-shopify-count', String(shopifyCount));
    knownShopifyCount = shopifyCount;
    bubbleLastWritten.set(node, label);
    var bubble = node.closest('.cart-count-bubble');
    if (bubble) bubble.classList.toggle('is-split', quoteCount > 0);
    if ((node.textContent || '').trim() !== label) {
      bubbleWriting = true;
      node.textContent = label;
      bubbleWriting = false;
    }
    var hidden = node.parentElement && node.parentElement.querySelector('.visually-hidden');
    if (hidden) {
      hidden.textContent = quoteCount > 0
        ? (quoteCount + ' in quote cart, ' + shopifyCount + ' in cart')
        : (shopifyCount === 1 ? '1 item' : shopifyCount + ' items');
    }
  }

  function shopifyFromNode(node) {
    var stored = node.getAttribute('data-shopify-count');
    if (stored != null && stored !== '') return Number(stored);
    var parsed = parseShopifyText(node.textContent);
    if (parsed != null) return parsed;
    if (knownShopifyCount != null) return knownShopifyCount;
    return 0;
  }

  var captionCart = null;
  var captionCartPromise = null;

  function refreshCaptionCart() {
    if (captionCartPromise) return captionCartPromise;
    captionCartPromise = fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        captionCart = cart;
        captionCartPromise = null;
        syncFurnitureCaption();
        return cart;
      })
      .catch(function () {
        captionCartPromise = null;
        return null;
      });
    return captionCartPromise;
  }

  function selectedProductCount() {
    var quote = window.Quottee;
    if (!quote || !captionCart || typeof quote.selectedCartCount !== 'function' || typeof quote.getQuoteState !== 'function') {
      return null;
    }
    return Number(quote.selectedCartCount(captionCart, quote.getQuoteState())) || 0;
  }

  function itemLabel(count, singular, plural) {
    return String(count) + ' ' + (Number(count) === 1 ? singular : plural);
  }

  function furnitureCaptionText() {
    var products = selectedProductCount();
    if (products == null) return '';
    return itemLabel(quoteQty(), 'Furniture item', 'Furniture items')
      + ' in quote cart and '
      + itemLabel(products, 'product item', 'product items');
  }

  function syncFurnitureCaption() {
    var host = document.querySelector('.cart-container .quottee-cart-host');
    if (!host) return;
    if (!captionCart) {
      refreshCaptionCart();
      return;
    }
    var text = furnitureCaptionText();
    if (!text) return;
    var note = host.querySelector('.quottee-cart-host__note');
    if (!note) {
      note = document.createElement('p');
      note.className = 'quottee-cart-host__note';
      host.appendChild(note);
    }
    if (note.textContent !== text) note.textContent = text;
  }

  function watchQuoteSelection(quote) {
    if (!quote || typeof quote.saveQuoteState !== 'function' || quote.saveQuoteState.__captionWrapped) return;
    var original = quote.saveQuoteState;
    quote.saveQuoteState = function () {
      var result = original.apply(quote, arguments);
      syncFurnitureCaption();
      return result;
    };
    quote.saveQuoteState.__captionWrapped = true;
  }

  function watchFurnitureCaption(tries) {
    syncFurnitureCaption();
    var root = document.querySelector('.cart-container');
    if (!root) {
      if ((tries || 0) < 40) window.setTimeout(function () { watchFurnitureCaption((tries || 0) + 1); }, 250);
      return;
    }
    if (root.dataset.furnitureCaptionWatch === 'true') return;
    root.dataset.furnitureCaptionWatch = 'true';
    var observer = new MutationObserver(syncFurnitureCaption);
    observer.observe(root, {
      childList: true,
      subtree: true,
      characterData: true
    });
    var quoteRoot = document.querySelector('.quottee-root');
    if (quoteRoot) observer.observe(quoteRoot, { childList: true, subtree: true, characterData: true });
  }

  function refreshCartBubbles() {
    document.querySelectorAll('.cart-count-bubble [data-cart-count]').forEach(function (node) {
      renderBubble(node, shopifyFromNode(node));
    });
    captionCart = null;
    refreshCaptionCart();
  }

  function watchCartBubbles() {
    if (document.documentElement.dataset.quoteBubbleWatch === 'true') return;
    document.documentElement.dataset.quoteBubbleWatch = 'true';
    var observer = new MutationObserver(function (mutations) {
      if (bubbleWriting) return;
      var needsRefresh = false;
      mutations.forEach(function (mutation) {
        if (mutation.type === 'childList') {
          Array.prototype.forEach.call(mutation.addedNodes, function (added) {
            if (!added || !added.querySelector) return;
            if ((added.matches && added.matches('.cart-count-bubble, [data-cart-count]')) || added.querySelector('.cart-count-bubble')) {
              needsRefresh = true;
            }
          });
          return;
        }
        var node = mutation.target;
        if (node && node.nodeType === 3) node = node.parentElement;
        if (!node || !node.matches || !node.matches('[data-cart-count]')) return;
        if (!node.closest('.cart-count-bubble')) return;
        var current = (node.textContent || '').trim();
        if (current === bubbleLastWritten.get(node)) return;
        var numeric = parseShopifyText(current);
        if (numeric == null) return;
        renderBubble(node, numeric);
      });
      if (needsRefresh) refreshCartBubbles();
    });
    observer.observe(document.documentElement, {
      subtree: true,
      characterData: true,
      childList: true
    });
    window.addEventListener('storage', function (event) {
      if (event.key !== 'quottee:v1:quote' && event.key !== 'quottee:v0.1:quote') return;
      refreshCartBubbles();
    });
    window.addEventListener('pageshow', refreshCartBubbles);
    refreshCartBubbles();
  }

  function watchQuotePrices(tries) {
    replaceZeroQuotePrices();
    var root = document.querySelector('.quottee-root');
    if (!root) {
      if ((tries || 0) < 40) window.setTimeout(function () { watchQuotePrices((tries || 0) + 1); }, 250);
      return;
    }
    if (root.dataset.quotePriceWatch === 'true') return;
    root.dataset.quotePriceWatch = 'true';
    var observer = new MutationObserver(function () {
      replaceZeroQuotePrices();
    });
    observer.observe(root, { childList: true, subtree: true, characterData: true });
  }

  watchCartBubbles();
  watchFurnitureCaption();

  waitForQuottee(function (Q) {
    wrapQuottee(Q);
    watchQuoteSelection(Q);
    watchQuotePrices();
    refreshCartBubbles();
    if (typeof Q.ensureCart === 'function') {
      Q.ensureCart().then(function () { wrapRenderLate(Q); });
    } else {
      wrapRenderLate(Q);
    }
  });

  function wrapRenderLate(Q) {
    if (typeof Q.renderQuoteDrawer === 'function' && Q.renderQuoteDrawer.__artworkWrapped) return;
    if (typeof Q.renderQuoteDrawer === 'function') {
      var original = Q.renderQuoteDrawer;
      Q.renderQuoteDrawer = function () {
        var result = original.apply(Q, arguments);
        window.setTimeout(function () { injectNotices(Q); }, 0);
        return result;
      };
      Q.renderQuoteDrawer.__artworkWrapped = true;
    }
    hookFetch(Q);
  }
})(window, document);
